import { IEmailAttachment } from 'Modules/Communication/Email/shared/models/Email'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'

export interface IEmailMessage {
  contentHtml: string
  title: string
  attachments?: IEmailAttachment[]
}

export interface ISmsMessage {
  content: string
}

export interface SendMessagePatchBody {
  op: 'replace'
  path: string
  value: string
}

export interface IMessageReciept {
  recipients: IMessageRecieptRecipient[]
  sendingStatus: SendMessageStatusEnum
}

export interface IMessageRecieptRecipient {
  id: string
  messageId: string
  name: string
  email: string
  recipientType: string
  nameregisterId: string
  phonenumber: string
  isSent: boolean
  validEmail: boolean
  validPhonenumber: boolean
  isExistingContact: boolean
  isAdded?: boolean
}

export interface ISendSmsSettings {
  unitPrice: number
  warningLimit: number
  maxLimit: number
  maxLengthSms: number
  smsHasBeenUsed: boolean
  isSmsAvailable: boolean
  numberOfSmsNotInvoiced: number
}

export interface ILoadingMessageRecipient {
  type: 'remove' | 'add'
  recipientType: RecipientTypeEnum
  id: string
}

export type SendEmailFieldName = 'title' | 'contentHtml'

export enum SendMessageStateEnum {
  send = 'send',
  reciept = 'reciept',
}

export enum SendMessageStatusEnum {
  Sent = 'Sent',
  Sending = 'Sending',
  Error = 'Error',
}
